import _defineProperty from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { progressClass } from './styles';
import { isRTL } from '../config';
var ROTATE_MAX_ANGLE = 15;
var PROGRESS_CENTER = 60;

var Popup =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Popup, _React$Component);

  var _super = _createSuper2(Popup);

  function Popup() {
    _classCallCheck(this, Popup);

    return _super.apply(this, arguments);
  }

  _createClass(Popup, [{
    key: "getStyle",
    value: function getStyle() {
      var _ref;

      var value = this.props.value;
      var rotate = 0;
      if (value <= PROGRESS_CENTER) rotate = ROTATE_MAX_ANGLE * (value / PROGRESS_CENTER);else rotate = (1 - value / 100) * ROTATE_MAX_ANGLE;
      return _ref = {}, _defineProperty(_ref, isRTL() ? 'right' : 'left', "".concat(value, "%")), _defineProperty(_ref, "transform", "translateX(".concat(isRTL() ? '50%' : '-50%', ") rotate(").concat(rotate, "deg)")), _ref;
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return (
        /*#__PURE__*/
        React.createElement("div", {
          className: progressClass('popup'),
          style: this.getStyle()
        },
        /*#__PURE__*/
        React.createElement("span", {
          className: progressClass('value')
        }, children),
        /*#__PURE__*/
        React.createElement("span", {
          className: progressClass('arrow')
        }))
      );
    }
  }]);

  return Popup;
}(React.Component);

export { Popup as default };